import { render, staticRenderFns } from "./MumbersAudit.vue?vue&type=template&id=2d161a16&scoped=true"
import script from "./MumbersAudit.vue?vue&type=script&lang=ts"
export * from "./MumbersAudit.vue?vue&type=script&lang=ts"
import style0 from "./MumbersAudit.vue?vue&type=style&index=0&id=2d161a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d161a16",
  null
  
)

export default component.exports